import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {

  constructor(
    private zone: NgZone,
    private injector: Injector
  ) {}

  private get router(): Router {
    return this.injector.get(Router);
  }

  handleError(error: any): void {
    const message = error?.message || '';
    const isChunkError =
      /Failed to fetch dynamically imported module/.test(message) ||
      /Loading chunk [\d]+ failed/.test(message) ||
      /ChunkLoadError/.test(message) ||
      /Failed to load module script/.test(message);

    console.error('[ErrorHandler]', error);

    if (isChunkError) {
      this.handleChunkError(message);
    }
  }

  private handleChunkError(message: string): void {
    const countKey = 'cer_count';       // chunk error reload count
    const timeKey  = 'cer_time';        // time of first error in this session

    const count = Number(sessionStorage.getItem(countKey) || '0');
    const firstErrorTime = Number(sessionStorage.getItem(timeKey) || '0');
    const now = Date.now();

    // Reset counter if last error was more than 5 minutes ago
    // (means it's a new navigation attempt, not a loop)
    const isNewSession = (now - firstErrorTime) > 5 * 60 * 1000;
    const effectiveCount = isNewSession ? 0 : count;

    if (effectiveCount === 0) {
      // First error — store timestamp
      sessionStorage.setItem(timeKey, String(now));
    }

    if (effectiveCount < 2) {
      sessionStorage.setItem(countKey, String(effectiveCount + 1));

      this.zone.run(async () => {
        // ✅ Add a small delay to let Cloudflare purge propagate
        await new Promise(resolve => setTimeout(resolve, 1500));

        if ('caches' in window) {
          const names = await caches.keys();
          await Promise.all(names.map(n => caches.delete(n)));
        }
        location.reload();
      });

    } else {
      // Reloaded twice and still failing — stop looping, show error
      sessionStorage.removeItem(countKey);
      sessionStorage.removeItem(timeKey);
      this.zone.run(() => {
        this.router.navigate(['/dashboard/error'], {
          queryParams: { reason: 'chunk-load-failed' }
        });
      });
    }
  }
}